import {
  CreateComponentDeploymentRequestsRequest,
  CreateComponentDeploymentRequestsResponse,
  DeploymentRequestsRestResource,
  GetDeploymentRequestsRequest,
  GetDeploymentRequestsResponse,
  UpdateComponentDeploymentRequestsRequest,
  UpdateComponentDeploymentRequestsResponse,
  UpdateComponentDeploymentRequestsStatusRequest,
  UpdateComponentDeploymentRequestsStatusResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetDeploymentRequests = () =>
  useRestResourceHook<
    GetDeploymentRequestsRequest,
    GetDeploymentRequestsResponse
  >((request) => DeploymentRequestsRestResource.getDeploymentRequests(request));

export const useUpdateComponentDeploymentRequestsStatus = () =>
  useRestResourceHook<
    UpdateComponentDeploymentRequestsStatusRequest,
    UpdateComponentDeploymentRequestsStatusResponse
  >((request) =>
    DeploymentRequestsRestResource.updateComponentDeploymentRequestsStatus(
      request,
    ),
  );

export const useUpdateComponentDeploymentRequests = () =>
  useRestResourceHook<
    UpdateComponentDeploymentRequestsRequest,
    UpdateComponentDeploymentRequestsResponse
  >((request) =>
    DeploymentRequestsRestResource.updateComponentDeploymentRequests(request),
  );

export const useCreateComponentDeploymentRequests = () =>
  useRestResourceHook<
    CreateComponentDeploymentRequestsRequest,
    CreateComponentDeploymentRequestsResponse
  >((request) =>
    DeploymentRequestsRestResource.createComponentDeploymentRequests(request),
  );
